<template>
  <div>
    <v-row>
      <v-col cosl="12">
        <v-card>
          <v-card-title class="primary--text">
            Guía de Estilos y Estándares con los componentes
          </v-card-title>
          <v-card-text class="text-center">
            Este módulo, diseñado para ser discreto, sirve como referencia visual y documental de los componentes y
            estándares adoptados en nuestra plataforma. Aquí, se documenta de manera detallada cada componente diseñado y
            desarrollado por nuestro equipo. Su objetivo es prevenir la duplicación de funcionalidades ya existentes, como
            modales, botones y estilos, y promover la coherencia al usar los mismos patrones a lo largo de toda la
            plataforma.
          </v-card-text>
        </v-card>

      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Uso de campos para formularios
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" class="text-h6 primary--text">
                        Uso de textfield
                      </v-col>
                      <v-col cols="6">
                        <p class="font-weight-bold">Icono del campo de texto</p>
                        <span class="caption">
                          icon="Recive un string"
                        </span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="icontext" />
                      </v-col>

                      <v-col cols="6">
                        <p class="font-weight-bold">texto sobre el textfield</p>
                        <span>
                          textLabel="Recibe un String"
                        </span>
                      </v-col>
                      <v-col cosl="6">
                        <textfieldComp v-model="textCampo" />
                      </v-col>

                      <v-col cols="6">
                        Cambio de textfield a textArea
                      </v-col>
                      <v-col cols="6">
                        <v-radio-group v-model="rediotextfield" column>
                          <v-radio label="Textfield" :value="false"></v-radio>
                          <v-radio label="TextArea" :value="true"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-text class="d-flex justify-center align-center">
                    <textfieldComp :icon="icontext" :textLabel="textCampo" :textArea="rediotextfield" />
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <p>
                      Ejemplo de las propiedades usadas
                    </p>
                    &lt;v-text-field :readonly="readonly" :disabled="disabled" v-model="internalValue"
                    @input="updateInternalValue" :prepend-icon="icon" :rules="rules" :type="type" color="primary"
                    :label="textLabel" class="mt-2 icon-size" hide-spin-buttons required&gt;

                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <v-divider />
              </v-col>

              <v-col cols="6">
                <v-card outlined>
                  <v-card-title class="primary--text">
                    Uso de autocomplete
                  </v-card-title>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="6">
                        <p class="font-weight-bold">Ponerle el texto al autocomplete</p>
                        <span class="caption">textLabel="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="textAutocomplete" />
                      </v-col>
                      <v-col cols="6">
                        <p class="font-weight-bold">icono del autocomplete</p>
                        <span class="caption">icon="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="iconAutocomplete" />
                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card outlined>
                  <v-card-text>
                    <AutocompleteComp :textLabel="textAutocomplete" :icon="iconAutocomplete" :items="Autocompleteitems" />
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <p>Propiedades de Ejemplo</p>
                    &lt;v-autocomplete class="py-3" v-model="internalValue" :label="textLabel" :items="items"
                    :item-text="itemText" :readonly="readonly" :item-value="itemValue" :multiple="multiple"
                    @change="handleChange" :rules="rules" :auto-select-first="autoSelectFirst" autocomplete="off"
                    :prepend-icon="icon" :disabled="isDisable" :return-object="returnObject"&gt;
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title class="primary--text">
            Uso de botones y tablas
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <p>Texto de Boton</p>
                        <span class="caption">textButton="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="textbutton" />
                      </v-col>
                      <v-col cols="6">
                        Icono de boton
                        <span class="caption">solo se permite en botones con texto iconBut="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="iconobutton" />
                      </v-col>
                      <v-col cols="6">
                        <p>Color del boton</p>
                        <span class="caption">El predeterminado es el primary si no se llega a colocar nada sera primary
                          classColor="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="colorbutton" />
                      </v-col>
                      <v-col cols="6">
                        <p>Tooltip</p>
                        <span class="caption">:tooltipText="String"</span>
                      </v-col>
                      <v-col cols="6">
                        <textfieldComp v-model="tooltiptext" />
                      </v-col>
                      <v-col cols="6">
                        <p>Uso de botones comunes para tablas y formularios</p>
                        <span class="caption">Solo se aplicaran cuano no se coloque texto al boton </span>
                      </v-col>

                      <v-col cols="6">
                        <v-container fluid>
                          <v-checkbox label="normalButton" v-model="normalbutton"></v-checkbox>
                          <v-checkbox label="deleteButton" v-model="deletebutton"></v-checkbox>
                          <v-checkbox label="addbutton" v-model="addbutton"></v-checkbox>
                          <v-checkbox label="editbutton" v-model="editbutton"></v-checkbox>
                          <v-checkbox label="verbutton" v-model="verbutton"></v-checkbox>
                          <v-checkbox label="downloadButton" v-model="downloadbutton"></v-checkbox>
                          <v-checkbox label="uploadButton" v-model="uploadbutton"></v-checkbox>
                          <v-checkbox label="listButton" v-model="listbutton"></v-checkbox>
                          <v-checkbox label="configButton" v-model="configbutton"></v-checkbox>
                        </v-container>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined>
                  <v-card-text>
                    <TableButtonComp :textButton="textbutton" :iconBut="iconobutton" :classColor="colorbutton"
                      :deleteButton="deletebutton" :addButton="addbutton" :editButton="editbutton" :verButton="verbutton"
                      :downloadButton="downloadbutton" :uploadButton="uploadbutton" :listButton="listbutton"
                      :configButton="configbutton" :normalButton="normalbutton" :tooltipText="tooltiptext" />
                  </v-card-text>
                </v-card>
                <v-card>

                  <v-card-text>
                    <span>Propiedades que se pueden usar para el componente</span>
                    <p>
                      &lt; template v-if="textButton && textButton !== ''"&gt;
                      <br />
                      &lt;v-btn :color="classColor ? classColor : 'primary'" :class="classButton" :small="!normalButton"
                      :disabled="disabled"
                      :dark="!disabled" @click="handleClick()" :href="href" target="_blank" :block="blockButton"
                      :loading="loading"
                      dense&gt;
                      <br />
                      &lt;v-icon left v-if="iconBut"&gt;
                      &lt; iconBut &gt;
                      &lt;/v-icon&gt;
                      <br />
                      &lt; textButton &gt;
                      &lt;/v-btn&gt;
                      &lt;/template&gt;
                    </p>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card>
          <v-card-title>
            Uso de tablas
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4">
                <v-card outlined>
                  <v-card-text>
                    <v-container fluid>
                      <v-checkbox v-model="searchcheck" label="Uso de buscador"></v-checkbox>
                      <span class="caption">Uso de buscador whitSearch="Booleano" </span>
                      <v-checkbox v-model="selectcheck" label="Uso de selects"></v-checkbox>
                      <span class="caption">Uso de select whitSelect="Booleano"</span>
                      <p>Texto del placeholder del buscador</p>
                      <textfieldComp v-model="placeholdersearch" />
                      <p>Texto cuando no hay data</p>
                      <textfieldComp v-model="nodatatext" />
                      <TableButtonComp @click="limpiararray" textButton="Limpiar array" iconBut="fas fa-trash"
                        classColor="red" />
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="8">
                <v-card outlined>
                  <v-card-text>
                    <ComundataTablecomp :items="desserts" :noResultsText="nodatatext"
                      :placeholderTextsearch="placeholdersearch" :whitSearch="searchcheck" :whitSelect="selectcheck"
                      :headers="headers">
                    </ComundataTablecomp>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12">
                <strong>Ejemplo de uso</strong>
                <p>
                  &lt;ComundataTableComp :headers="ConfigGradosWebmasterHeaders" :items="GradosMantenimiento" whitSearch
                  placeholderTextsearch="Buscar grado" noResultsText="Sin grados registrados"&gt;
                  <br />
                  &lt;template v-slot:desc_nivel="{ item }"&gt;
                  <br />
                  &lt;div class="chip" :style="{ background: item.ck1_mant_niveles[0].color }"&gt;
                  item.ck1_mant_niveles[0].desc_nivel
                  &lt;/div&gt;
                  <br />
                  &lt;/template&gt;
                  <br />
                  &lt;template v-slot:action_editar="{ item }"&gt;
                  <br />
                  &lt;TableButtonComp v-if="componenteEvento.editar_submodulo" @click="editItem(item)" editButton
                  tooltipText="Editar grado" /&gt;
                  <br />
                  &lt;/template&gt;
                  <br />
                  &lt;template v-slot:action_borrar="{ item }"&gt;
                  <br />
                  &lt;TableButtonComp v-if="componenteEvento.borrar_submodulo" @click="deleteConfirm(item)" deleteButton
                  tooltipText="Eliminar grado" /&gt;
                  <br />
                  &lt;/template&gt;
                  &lt;/ComundataTableComp&gt;
                </p>
              </v-col>
            </v-row>

          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12">
        <v-card>
          <v-card-title>
            Componente para modales
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-card outlined>
                  <v-card-text>
                    <v-checkbox v-model="modalformulario" label="formulario normal"></v-checkbox>
                    <textfieldComp textLabel="Tamaño del modal" v-if="modalformulario" v-model="maximotama" />
                    <v-checkbox v-model="modalconfirm" label="formulario de confirmacion"></v-checkbox>
                    <v-checkbox v-model="modaldelete" label="formulario de eliminación"></v-checkbox>
                    <p class="strong">Colocar texto de delete o confirm</p>
                    <span class="caption">titleWindow="String"</span>
                    <textfieldComp v-model="titulomini" />
                    <p class="Strong">Colocar texto al titulo</p>
                    <span>title="String" o tambien puedes acceder a traves del slot:title</span>
                    <textfieldComp v-model="titulo" />
                    <p class="Strong">Colocar texto en el cuerpo</p>
                    <span>puedes acceder a traves del slot:body</span>
                    <textfieldComp v-model="bodytext" />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="8">
                <v-card outlined>
                  <v-card-text>
                    <TableButtonComp textButton="Ver modal" iconBut="fas fa-plus" @click="dinamicmodal = true" />
                    <ComunDialogComp v-model="dinamicmodal" :maxWidth="maximotama" @close-modal="dinamicmodal = false"
                      @cancel-item="dinamicmodal = false" :title="titulo" :Confirmdialog="modalconfirm"
                      :Deletedialog="modaldelete" :titleWindow="titulomini">
                      <template v-slot:body>
                        {{ bodytext }}
                      </template>
                      <template v-slot:actions>
                        zona accesible a traves de v-slot:actions
                        <TableButtonComp textButton="Zona de acciones" />
                      </template>
                    </ComunDialogComp>
                  </v-card-text>
                </v-card>
                <v-card>
                  <v-card-text>
                    <v-row>
                      <v-col cols="6">
                        <p>Acciones de modal confirmacion no permite Maxwidth</p>
                        &lt;v-btn @click="$emit('confirm-item')" color="primary" text&gt;
                        <br />
                        SÍ
                        <br />
                        &lt;/v-btn&gt;
                        <br />
                        &lt;v-btn @click="$emit('cancel-item')" color="red" text&gt;
                      </v-col>
                      <v-col cols="6">
                        <p>Acciones de modal de eliminacion no permite maxWidth"</p>
                        &lt;v-btn @click="$emit('delete-item')" color="primary" text&gt;
                        <br />
                        <!-- <v-icon small> fas fa-trash-alt</v-icon> -->
                        SÍ
                        &lt;/v-btn&gt;
                        <br />
                        &lt;v-btn @click="$emit('cancel-item')" text color="red"&gt;
                        <br />
                        No
                        &lt;/v-btn&gt;
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>

              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>Reglas e implementacion de headers</v-card-title>
          <v-card-text>
            importacion de headers del acrhivo
            <br>
            import ConfigGradosWebmasterHeaders from "../../../../helpers/headersTable.js";
            <br>
            *Se tiene q definir dentro del data
            <br>
            importacion de rules del archivo
            <br>
            import validationRules from "../../../../helpers/validatorHelpers.js";
            <br>
            se define en el computedd
            <br>
            validationRules {
            return validationRules;
            },

          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
    <div class="devStyle">
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <v-row>
        <v-col>
          <h2 class="">
            <v-icon color="info">mdi-palette</v-icon>

          </h2>
          <p>

          </p>
          Ubicacion de este archivo <code>/src/views/Dev/DevStyle.vue</code>


        </v-col>
      </v-row>
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <v-row>
        <v-col cols='6' sm='5'>
          <h4>COLORES ESTABLECIDOS POR VUETIFY</h4>
          <p>Estos son los lorores principales que se usan en la plataforma, la configuración de colores se encuentra en
            <code>client\src\plugins\vuetify.js</code>
          </p>
          <div class="d-flex flex-wrap">
            <div class="bdr text-center ma-2" v-for="color in Object.keys(colores_vuetify)" :key="color">
              <span>{{ color }}</span>
              <div :style="{ background: colores_vuetify[color] }" class="pa-3">
                {{ colores_vuetify[color] }}
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols='6' sm='7'>
          <h4 class="my-2">Ejemplo de uso</h4>

          <br>
          <div class="d-flex flex-wrap justify-space-around align-center">
            <div class="success text-center pa-5">
              <span class="white--text">Texto blanco fondo verde</span>
            </div>
            <div>
              <code>
                                                                                                                        &lt;div&nbsp;class=&quot;success&nbsp;text-center&nbsp;pa-5&quot;&gt;<br/>&nbsp;&nbsp;&lt;span&nbsp;class=&quot;white--text&quot;&gt;Texto&nbsp;blanco&nbsp;fondo&nbsp;verde&lt;/span&gt;<br/>&lt;/div&gt;
                                                                                                                      </code>
            </div>



          </div>
        </v-col>

      </v-row>
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <v-row>
        <v-col cols="6" md="4">
          <h4>Botones</h4>
          <p>Por motivos prácticos, usaremos los botones proporcionados por Vuetify. Sin embargo, estableceremos
            claramente las clases y propiedades con las que operaremos.</p>
          <a href="https://v2.vuetifyjs.com/en/components/buttons/#usage" target="_blank">Documentación de Vuetify 2</a>
          <h4>Propiedades:</h4>
          <div><strong>Tamaño:</strong> <b>small | x-large | x-small | large</b></div>
          <div><strong>Otras:</strong> <b>loading | disabled | block | icon</b></div>
          <!-- Parece que hay una línea repetida sobre tamaños, la he eliminado. Si esto es un error, simplemente puedes reincorporarla. -->

          <div>
            Código: <br>
            <code>
                                                                                                                      <!-- <v-btn class="btn_block_style2">Texto</v-btn> -->
                                                                                                                      &lt;v-btn&nbsp;class=&quot;btn_block_style2&quot;&gt;Texto&lt;/v-btn&gt;
                                                                                                                    </code>
          </div>

          <h4>Pruebame:</h4>
          <div class="d-flex flex-wrap ">
            <div class="my-2">
              <code>loading="bool" | onClick="function()" | color="str" </code> <br>
              <v-btn :loading="loadingBtn" @click="handleBtnLoad"
                :color="loadingBtn ? 'warning' : 'info'">Petición</v-btn>
            </div>

            <div class="my-2">
              <code>disabled="bool"| icon | fab | x-small </code> <br>
              <v-btn icon disabled color="red ">
                <v-icon>thumb_down</v-icon>
              </v-btn>
              <v-btn icon color="blue ">
                <v-icon>thumb_up</v-icon>
              </v-btn>
              <v-btn class="mx-2" fab x-small dark color="indigo">
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
              <v-btn color="blue-grey" class="ma-2 white--text">
                Upload
                <v-icon right dark>
                  mdi-cloud-upload
                </v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
        <v-col cols="6" md="8">
          <h4>Clases globales:</h4>
          <div class="d-flex flex-wrap bdr">
            <div v-for="(clase, i) in clasesBtns" :key="i" class="pa-2">
              <code>.{{ clase }}</code>
              <br>
              <v-btn :class="clase" elevation="2">Ejemplo</v-btn>
            </div>
          </div>

        </v-col>
      </v-row>

      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->

      <v-row>
        <v-col cols="6">
          <h4>Describe tu componente aquí</h4>
          <p>Describir cada componente nuevo para mantener el estandar </p>
        </v-col>

      </v-row>
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <!-- XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX -->
      <v-row>
        <v-col cols="6">

        </v-col>
        <v-col cols="6">

        </v-col>

      </v-row>





    </div>
  </div>
</template>


// PAGINA PARA FORMATEAR HTML EN TEXTO 
// https://www.htmlescape.net/htmlescape_tool.html

<script>

// import BtnComp from '@/components/ComponentsEst/BtnComp.vue'
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
// import fileinputCompVue from '../../components/ComponentsEst/fileinputComp.vue';
import '@/assets/css/global.css'
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import textfieldComp from '../../components/ComponentsEst/textfieldComp.vue';
import TableButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';


export default {
  components: {
    textfieldComp,
    // BtnComp,
    AutocompleteComp,
    TableButtonComp,
    ComundataTablecomp,
    ComunDialogComp
  },
  data() {
    return {
      // textfields variables de entorno
      icontext: "",
      textCampo: "",
      rediotextfield: false,
      // autocompletes variables de entorno
      textAutocomplete: "",
      iconAutocomplete: "",
      Autocompleteitems: ['foo', 'bar', 'fizz', 'buzz'],
      // textbutton variables de entorno
      textbutton: "",
      iconobutton: "",
      colorbutton: "",
      normalbutton: false,
      deletebutton: false,
      addbutton: false,
      editbutton: false,
      verbutton: false,
      downloadbutton: false,
      listbutton: false,
      configbutton: false,
      uploadbutton: false,
      tooltiptext: "",

      // table variables de entorno
      searchcheck: false,
      selectcheck: false,
      placeholdersearch: "",
      nodatatext: "",
      headers: [
        {
          text: 'Dessert (100g serving)',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Calories', value: 'calories' },
        { text: 'Fat (g)', value: 'fat' },
        { text: 'Carbs (g)', value: 'carbs' },
        { text: 'Protein (g)', value: 'protein' },
        { text: 'Iron (%)', value: 'iron' },
      ],
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
          fat: 6.0,
          carbs: 24,
          protein: 4.0,
          iron: 1,
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
          fat: 9.0,
          carbs: 37,
          protein: 4.3,
          iron: 1,
        },
        {
          name: 'Eclair',
          calories: 262,
          fat: 16.0,
          carbs: 23,
          protein: 6.0,
          iron: 7,
        },
        {
          name: 'Cupcake',
          calories: 305,
          fat: 3.7,
          carbs: 67,
          protein: 4.3,
          iron: 8,
        },
        {
          name: 'Gingerbread',
          calories: 356,
          fat: 16.0,
          carbs: 49,
          protein: 3.9,
          iron: 16,
        },
        {
          name: 'Jelly bean',
          calories: 375,
          fat: 0.0,
          carbs: 94,
          protein: 0.0,
          iron: 0,
        },
        {
          name: 'Lollipop',
          calories: 392,
          fat: 0.2,
          carbs: 98,
          protein: 0,
          iron: 2,
        },
        {
          name: 'Honeycomb',
          calories: 408,
          fat: 3.2,
          carbs: 87,
          protein: 6.5,
          iron: 45,
        },
        {
          name: 'Donut',
          calories: 452,
          fat: 25.0,
          carbs: 51,
          protein: 4.9,
          iron: 22,
        },
        {
          name: 'KitKat',
          calories: 518,
          fat: 26.0,
          carbs: 65,
          protein: 7,
          iron: 6,
        },
      ],

      // modales variables de entorno
      dinamicmodal: false,
      modalformulario: false,
      modalconfirm: false,
      modaldelete: false,
      titulomini: "",
      titulo: "",
      bodytext: "",
      maximotama: "",




      colores_vuetify: this.getThemeColors(),
      // ACÁ DEBEN ESTAR LAS CLASES DE LOS BTNS QUE SE ENCUENTRAN EN global.css

      // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
      clasesBtns: [
        "btn_block_style2",
        "btn_leyenda",
        "btn_style3",
        "btn_style4",
        "btn_style5",
        "btn_green",
        "btn_agregar",
        "btn_editar",
        "btn_editar2",
        "btn_guardar",
        "btn_ver",
        "btn_eliminar",
        "btn_imprimir",
        "btn_deshabilitar",
        "btn_virtual",
        "btn_descargar",
        "btn_otro",
        "btn_asignar"
      ],
      loadingBtn: false



      // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    }
  },
  computed: {
    // nameColors(){
    //   console.log(this.colores_vuetify_light);

    //   return Object.keys(this.colores_vuetify_light)
    // }
  },
  created() {
  },
  methods: {
    getThemeColors() {
      const themeType = this.$vuetify.theme.dark ? 'dark' : 'light'
      return { ...this.$vuetify.theme.themes[themeType] };
    },

    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
    handleBtnLoad() {
      this.loadingBtn = !this.loadingBtn
      setTimeout(() => {
        this.loadingBtn = !this.loadingBtn
      }, 1500);
    },
    limpiararray() {
      this.desserts = []
    }

    // Método para cambiar la propiedad del componente según el botón seleccionado

    // xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
  },

}
</script>



<style lang="scss">
.devStyle {
  .row {
    border: 1px solid grey
  }

  .bdr {
    border: 1px solid grey
  }


}
</style>


<style scoped >
/* ROOT */
/* estos son las variables colores de root que define vuetify y pudieron ser modificados por nosotros */
/* :clasequenoexiste {
    --v-anchor-base: #1565c0;
    --v-primary-base: #1565c0;
    --v-primary-lighten5: #bfe9ff;
    --v-primary-lighten4: #a1cdff;
    --v-primary-lighten3: #83b2ff;
    --v-primary-lighten2: #6497f9;
    --v-primary-lighten1: #437edc;
    --v-primary-darken1: #004ea4;
    --v-primary-darken2: #00378a;
    --v-primary-darken3: #002370;
    --v-primary-darken4: #000e57;
    --v-secondary-base: #bdbdbd;
    --v-secondary-lighten5: #ffffff;
    --v-secondary-lighten4: #ffffff;
    --v-secondary-lighten3: #ffffff;
    --v-secondary-lighten2: #f5f5f5;
    --v-secondary-lighten1: #d9d9d9;
    --v-secondary-darken1: #a2a2a2;
    --v-secondary-darken2: #888888;
    --v-secondary-darken3: #6e6e6e;
    --v-secondary-darken4: #565656;
    --v-accent-base: #82b1ff;
    --v-accent-lighten5: #ffffff;
    --v-accent-lighten4: #f8ffff;
    --v-accent-lighten3: #daffff;
    --v-accent-lighten2: #bce8ff;
    --v-accent-lighten1: #9fccff;
    --v-accent-darken1: #6596e2;
    --v-accent-darken2: #467dc6;
    --v-accent-darken3: #2364aa;
    --v-accent-darken4: #004c90;
    --v-error-base: #ff5252;
    --v-error-lighten5: #ffe4d5;
    --v-error-lighten4: #ffc6b9;
    --v-error-lighten3: #ffa99e;
    --v-error-lighten2: #ff8c84;
    --v-error-lighten1: #ff6f6a;
    --v-error-darken1: #df323b;
    --v-error-darken2: #bf0025;
    --v-error-darken3: #9f0010;
    --v-error-darken4: #800000;
    --v-info-base: #2196f3;
    --v-info-lighten5: #d4ffff;
    --v-info-lighten4: #b5ffff;
    --v-info-lighten3: #95e8ff;
    --v-info-lighten2: #75ccff;
    --v-info-lighten1: #51b0ff;
    --v-info-darken1: #007cd6;
    --v-info-darken2: #0064ba;
    --v-info-darken3: #004d9f;
	}  */
</style>